import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ResolvePopup from 'components/ResolvePopup';

import './NewDocumentTag.styles.scss';

type NewDocumentTagProps = {
  className?: string;
  tooltip?: string;
};

const NewDocumentTag: React.FC<NewDocumentTagProps> = (props) => {
  const { className, tooltip } = props;

  const classes = classNames('new-document-tag', className);

  const { t } = useTranslation();

  const content = useMemo(
    () => (
      <div className="new-document-tag__content">
        <span />
        {t('new')}
      </div>
    ),
    [t],
  );

  if (tooltip)
    return (
      <div className={classes}>
        <ResolvePopup onHover popupContent={tooltip}>
          {content}
        </ResolvePopup>
      </div>
    );

  return <div className={classes}>{content}</div>;
};

export default NewDocumentTag;
